export default __webpack_public_path__ + "static/media/Digital-Ready-Infrastructure.90ff53a2.svg";